


import screen1 from "./screen1.png";

const project_data = {
    tittle:"Url shortener for AWS",
    source:"https://github.com/juanda2222/primary_bid_skill_assestment",
    website:"https://github.com/juanda2222/primary_bid_skill_assestment",
    abstract:"Url shortened built with nodejs and Express. The manager page was built in vuejs using Mongodb and the system was deployed in AWS",
    hashtags:["vuejs", "node", "mongo", "aws", "typescript"],
    prev_image_index: 0,
    images:[
        {
            caption:"Setup page for the url shortener", 
            image:screen1
        }
    ]
}

export default project_data

